/**
 * Global app footer rendered by `AppShell` on every route.
 *
 * Two-column layout on desktop (DECE attribution left, SOLVED credit right),
 * stacked on mobile. Intentionally minimal — the page's primary calls-to-
 * action live in the content area, the footer is just a quiet strip for
 * ownership, copyright, version, and credit.
 */
export function AppFooter() {
  const year = new Date().getFullYear();
  return (
    <footer
      role="contentinfo"
      className="border-t border-border/70 bg-background"
    >
      <div className="mx-auto flex w-full max-w-7xl flex-col items-center gap-2 px-6 py-3 text-xs text-muted-foreground sm:flex-row sm:justify-between">
        <div className="flex items-center gap-2 text-center sm:text-left">
          <span className="font-semibold tracking-wide text-dece-navy">
            DECE
          </span>
          <span aria-hidden className="text-border">
            ·
          </span>
          <span>
            © {year} Division of Early Childhood Education
          </span>
          <span aria-hidden className="hidden text-border sm:inline">
            ·
          </span>
          <span
            className="hidden sm:inline"
            title={`FCCERS Tool v${__APP_VERSION__}`}
          >
            v{__APP_VERSION__}
          </span>
        </div>
        <div className="flex items-center gap-1.5">
          <span>Powered by</span>
          <a
            href="https://www.solvedconsulting.com"
            target="_blank"
            rel="noreferrer noopener"
            className="font-serif font-semibold tracking-wider text-dece-navy underline-offset-4 hover:underline focus-visible:underline focus-visible:outline-none"
          >
            SOLVED
          </a>
        </div>
      </div>
    </footer>
  );
}
